
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-remark',
  templateUrl: './remark.component.html',
  styleUrls: ['./remark.component.css']
})
export class RemarkComponent implements OnInit {

  datas
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<RemarkComponent>) { 
    this.datas = data    
  }

  ngOnInit(): void {
  }
  cancelReason() {
    this.dialogRef.close();
  }

}
